function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill-rule: evenodd;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M410.938,387.109c10.667,0.747,36.514,29.333,38.671,39.453q0.977,24.217,1.953,48.438c1.2,7.9,3.43,29.522.391,35.938l-17.578,15.624H369.531l-7.812-5.468c-4.147-2.767-11.225-5.073-12.891-10.156-3-9.169-1.139-41.93-.39-51.563,0.846-10.9-2.087-24.823,1.171-32.813,4.6-11.279,22.28-34.586,33.594-38.281Zm-9.376,17.969-13.281.391c-8.489,2.1-27.351,14.248-30.859,21.093q-0.2,7.032-.391,14.063-0.39,8.789-.781,17.578c1.3,4.066,13.309,10.971,17.578,12.109,4.058-5.767,8.773-11.479,14.453-15.624h23.438l13.672,14.453,1.171-.391,16.407-14.062q-0.781-14.647-1.563-29.3C429.874,417.044,421.474,405.023,401.562,405.078Z"
});

var SvgMBeardBalboLongSquareVector = function SvgMBeardBalboLongSquareVector(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "m_beard_balbo_long-square_vector",
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMBeardBalboLongSquareVector, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/m_beard_balbo_long__square_vector.b5506486.svg";
export { ForwardRef as ReactComponent };